import { Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';
import { SidebarListItem } from '../sidebar.component';
import { WorkspaceSidebarItemDto } from 'src/models/ts/workspace-sidebar-item-dto.model';
import { SidebarService } from '../../../../services/sidebar/sidebar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WorkspaceItemType } from 'src/models/ts/workspace-item-type.model';
import { SidebarLinkComponent } from 'src/app/shared/components/ui/sidebar/sidebar-link/sidebar-link.component';

@Component({
  selector: 'bizz-sidebar-block',
  standalone: true,
  imports: [CommonModule, IconComponent, SidebarLinkComponent],
  templateUrl: './sidebar-block.component.html',
  styleUrls: ['./sidebar-block.component.scss']
})
export class SidebarBlockComponent {
  @Input() public sidebarListItem: SidebarListItem;
  @Input() public children: WorkspaceSidebarItemDto[];
  @Input() public offline = false;
  @Input() public isMobile: boolean;
  @Input() public workspaceId: number;
  @Output() public mobileRoutingClicked = new EventEmitter<void>();

  public newTableViewRecordLinkActive = false;
  public sidebarState: 'in' | 'out' = 'out';
  public expanded = this.sidebarService.getObservable();

  public constructor(
    private sidebarService: SidebarService,
    private destroyRef: DestroyRef,
  ) {
    this.expanded.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (expanded) => {
        this.sidebarState = expanded ? 'out' : 'in';
        this.toggleContent(!expanded);
      }
    });
  }

  public openLink(sidebarListItem: SidebarListItem | WorkspaceSidebarItemDto): void {
    this.newTableViewRecordLinkActive = false;
    if (sidebarListItem.ItemType == WorkspaceItemType.ExternalLink) {
      window.open(sidebarListItem.URL, '_blank');
      return;
    }
  }

  public slideSidebar(): void {
    if (this.isMobile) {
      this.mobileRoutingClicked.emit();
    }
  }

  private toggleContent(collapsed: boolean): void {
    if (this.sidebarListItem)
      this.sidebarListItem.collapsed = collapsed;
  }

  protected readonly WorkspaceItemType = WorkspaceItemType;
}
